<template>
  <div>
    <b-card no-body class="mb-1 mt-1">
      <b-card-body>
        <b-row>
          <b-col cols="8">
            <UsersTable
              v-bind:users="users"
              v-bind:roles="roles"
              :deals="deals"
              :scenarios="scenarios"
              @backgroundActivity="onBackgroundActivity"
              @userNotification="onUserNotification"
              @userChanged="onUserChanged"/>
          </b-col>
          <b-col cols="4">
            <b-row class="mb-2">
              <b-col>
                <AddUserForm
                  v-bind:roles="roles"
                  @backgroundActivity="onBackgroundActivity"
                  @userChanged="onUserChanged"/>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col>
                <assign-deal-to-all-users
                  :deals="deals"
                  :users="users"
                  @backgroundActivity="onBackgroundActivity"
                  @userChanged="onUserChanged"/>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col>
                <AdminFunctions 
                  @backgroundActivity="onBackgroundActivity"
                  @userChanged="onUserChanged"/>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import service              from '../../services/HttpRequestService';
import AddUserForm          from './AddUserForm';
import UsersTable           from './UsersTable';
import AssignDealToAllUsers from './AssignDealToAllUsers';
import AdminFunctions       from './AdminFunctions';
import ObjSpinnerState      from "@/components/common/spinner/ObjSpinnerState";
import ObjAlertState        from "@/components/common/alert/ObjAlertState";

import { withUINotification } from '../../hooks/UserNotifications';

export default {
  data() {
    return {
      users:     [],
      roles:     [],
      deals:     [],
      scenarios: [],
      ObjSpinnerState,
      ObjAlertState
    };
  },
  async created() {
    try {
      this.ObjSpinnerState.isOn = true;
      await withUINotification.bind(this)(async () => {
        const results = await Promise.allSettled([
          service.getUsers(),
          service.getRoles(),
          service.getDealsNames()
        ]);
        const [
          { value: { data: users = [] } } = {},
          { value: { data: roles = [] } } = {},
          { value: { data: deals = [] } } = {} ] = results;
        this.users = users;
        this.roles = roles.map(r => ({ text: r.Name, value: r.Name }))
        this.deals = deals;
      });
    } finally {
      this.ObjSpinnerState.isOn = false;
    }
  },
  methods: {
    onBackgroundActivity({ value: inProgress = false }) {
      this.ObjSpinnerState.isOn = inProgress;
    },
    onUserNotification(notification) {
      const { message, payload: { subType } } = notification;
      if (message && subType) {
        const alertType = (subType === 'success')
          ? 'success'
          : (subType === 'error')
            ? 'danger'
            : 'danger';
        this.ObjAlertState.set(message, alertType);
      }
    },
    async onUserChanged(notification) {
      const { value: userId } = notification;
      if (userId) {
        const idx = this.users.findIndex(({ Id: id }) => id === userId);
        if (idx !== -1) {
          const { data } = await service.getUser(userId);
          this.users[idx] = Object.assign(this.users[idx], data);
        }
      }
    }
  },
  components: {
    AddUserForm,
    UsersTable,
    AssignDealToAllUsers,
    AdminFunctions
  }
};
</script>

<style lang="scss" scoped>
.password-button {
  font-size: 0;
  text-align: right;
}

.form-control {
  text-align: right;
}

.eye {
  line-height: 1;
}
</style>
